// material-ui
// import { useTheme } from '@mui/material/styles';
import { UserContext } from 'layout/MainLayout';

import { Stack, Avatar, Typography } from '@mui/material';
// project imports
// import UpgradePlanCard from './UpgradePlanCard';
// import User1 from 'assets/images/users/user-round.svg';
import { useContext } from 'react';
import { lengthOfObject } from 'views/versions/tabs/Constfunctions';
// assets
import { deepOrange } from '@mui/material/colors';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  // using the Context value
  const user = useContext(UserContext);

  const stringAvatar = (user) => {
    return {
      children: `${user.split(' ')[0][0]}${user.split(' ')[1][0]}`
    };
  };

  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          height: '50px',
          alignItems: 'center',
          fontWeight: 'bold'
        }}
      >
        <Avatar
          {...stringAvatar(`${user.FirstName} ${user.LastName}`)}
          sx={{
            fontWeight: 'normal',
            height: '45px',
            width: '45px',
            bgcolor: deepOrange[300],
            color: '#fff',
            margin: '0 15px 0 3px !important'
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Typography fontWeight={600}>{user && lengthOfObject(user) !== 0 ? user.FirstName + ' ' + user.LastName : 'Guest'}</Typography>
          <Typography>
            <strong>Role: </strong>
            {user.UserRole}
          </Typography>
        </div>
      </Stack>
    </>
  );
};

export default ProfileSection;
